import { Box } from '@mui/material';
import { DataGridPro } from '@mui/x-data-grid-pro';
import type { GridApiPro } from '@mui/x-data-grid-pro';
import type { FailedInvoiceDeliveriesReportItem } from '@vy/types';
import React from 'react';
import { EmptyTableOverlay } from '../../../../components/design/EmptyTableOverlay';
import { LoadingOverlay } from '../../../../components/new-design/table/vy-table/VyTable';
import { FAILED_INVOICE_DELIVERIES_REPORT_COLUMNS } from './FailedInvoiceDeliveriesReportTableColumns';

type FailedInvoiceDeliveriesReportTableProps = {
  rows: FailedInvoiceDeliveriesReportItem[];
  apiRef?: React.MutableRefObject<GridApiPro>;
  isLoading?: boolean;
};

export const FailedInvoiceDeliveriesReportTable: React.FC<FailedInvoiceDeliveriesReportTableProps> = ({
  rows,
  apiRef,
  isLoading,
}) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <DataGridPro
        apiRef={apiRef}
        rows={rows}
        columns={FAILED_INVOICE_DELIVERIES_REPORT_COLUMNS}
        loading={isLoading}
        getRowId={(row) => `${row.customer.id}-${row.invoice.id}-${row.date}`}
        density="compact"
        pagination
        slots={{
          noRowsOverlay: EmptyTableOverlay,
          loadingOverlay: LoadingOverlay,
        }}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 25,
            },
          },
        }}
      />
    </Box>
  );
};
